import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles(({
  breakpoints, fontSizes,
}: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    '&&': {
      border: 'none',
      borderRadius: 0,
      boxShadow: 'none',
    },
  },
  brand: {
    position: 'relative',
    maxWidth: 'calc(100% - 3.5rem)',
    margin: 0,
    paddingLeft: '1.875rem',
    fontSize: fontSizes.sm,
    lineHeight: 1.5,
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    [breakpoints.up('sm')]: {
      maxWidth: 'calc(100% - 4.5rem)',
    },
  },
  image: {
    objectFit: 'contain',
    width: '3rem',
    marginTop: '0.125rem',
    marginRight: '0.5rem',
    [breakpoints.up('sm')]: {
      width: '3.75rem',
      marginRight: '0.75rem',
    },
  },
  imageSolutionsWrapper: {
    display: 'flex',
    justifyContent: 'center',
    width: '3rem',
    marginTop: '0.125rem',
    marginRight: '0.5rem',
    [breakpoints.up('sm')]: {
      width: '3.75rem',
      marginRight: '0.75rem',
    },
  },
  imageSolutions: {
    objectFit: 'contain',
    width: 'auto',
    height: '2.8125rem',
    [breakpoints.up('sm')]: {
      height: '3.375rem',
    },
  },
  number: {
    position: 'absolute',
    left: 0,
    top: 0,
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: fontSizes.sm,
  },
  profileLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    flexShrink: 0,
  },
  packSize: {
    lineHeight: 1,
  },
}));
